import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangeTabsService {
  public tabVinsBuques: BehaviorSubject<any> = new BehaviorSubject<any>("");
  constructor() { }

  changeVinsBuques(value){
    this.tabVinsBuques.next(value);
  }

}
